import { MarketingNav } from "@/components/MarketingNav";
import { MarketingFooter } from "@/components/MarketingFooter";

export const MarketingLayout = ({ children }) => (
  <div className="min-h-screen bg-ho-bg">
    <MarketingNav />
    <main>{children}</main>
    <MarketingFooter />
  </div>
);
